import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class AddNoteBuilder {
  constructor() {}

  buildFormControl(note: string): FormControl {
    return new FormControl(note, Validators.maxLength(4000));
  }
}
